<template>
  <div>
    <review-question
      v-for="(question, index) in questions"
      :hide-change-links="hideChangeLinks"
      :question="question"
      :question-id="index"
      :is-resident="isVoterResident"
      :key="index"
    ></review-question>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import ReviewQuestion from './ReviewQuestion.vue';

export default {
  props: {
    questions: {
      type: Array,
      required: true
    },
    hideChangeLinks: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ReviewQuestion
  },
  computed: {
    ...mapGetters('resident', ['isVoterResident'])
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Review/ReviewQuestions.vue